// Bank Reconciliation Permissions
//
// The central key service's approval numbers, issued 21 September 2026 — the
// same numbers the backend migration writes as each permission row's id, so the
// two must stay equal. Read an issued id, never derive the next one from the
// last.
//
// There is deliberately **no `_SHOW`**. `routes/api/dashboard/bank-reconciliation.php`
// guards the detail route — and the summary, the statement lines, the
// suggestions and the unmatched-ledger list — with `bank_reconciliations.index`,
// on the August 2026 audit's rule that whoever may read the register may read
// what is in it. The record route therefore gates on `BANK_RECONCILIATIONS_INDEX`;
// inventing a `_SHOW` id here would name a key that does not exist and answer 400.
//
// There is no `_RESTORE` either: no such key was registered, so no route may
// name one. The register can still be viewed in `only_trashed` mode — a deleted
// reconciliation is readable, just not recoverable from here.

export const BANK_RECONCILIATIONS_INDEX = 1604;
export const BANK_RECONCILIATIONS_CREATE = 1605;
export const BANK_RECONCILIATIONS_UPDATE = 1606;
export const BANK_RECONCILIATIONS_DELETE = 1607;
export const BANK_RECONCILIATIONS_IMPORT = 1608;

/**
 * Match, unmatch and flag share one key. They are the same authority over the
 * same decision — pairing a statement line with an entry — and splitting them
 * would grant nothing new. Unmatch especially: a match that could not be taken
 * back by whoever made it is a match nobody would dare make.
 */
export const BANK_RECONCILIATIONS_MATCH = 1609;

export const BANK_RECONCILIATIONS_COMPLETE = 1610;
